import { AfterViewInit, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { debounceTime } from '../../../../../node_modules/rxjs/operators';
import { distinctUntilChanged } from '../../../../../node_modules/rxjs/operators';

import { fuseAnimations } from '@fuse/animations';
import { Task } from '../../../shared/models/task';
import { enumTaskSelection, TaskService } from '../../../shared/services/task.service';
import { ListFilterItem, ListSortOrderItem } from '../../../shared/services/listSortAndFilterHelpers';
import { TaskDialogComponent, TaskDialogData } from './task-dialog/task-dialog.component';
import { AuthService } from 'app/shared/services/auth.service';

@Component({
    selector: 'fuse-task',
    templateUrl: './task.component.html',
    styleUrls: ['./task.component.scss'],
    animations: fuseAnimations,
})
export class FuseTaskComponent implements OnInit, OnDestroy, AfterViewInit {
    searchInput: UntypedFormControl;
    currentTask: Task;
    onNewTaskClicked: Subscription;
    onSearchInputValueChanges: Subscription;
    filter: ListFilterItem;
    userReadOnly = false;

    taskSelection: enumTaskSelection = enumTaskSelection.AllTasks;

    @Input() showListToolbar: boolean;
    taskFormSearch: UntypedFormGroup;

    constructor(public taskService: TaskService,
        private dialog: MatDialog,
        private route: ActivatedRoute,
        private authService: AuthService) {
        this.searchInput = new UntypedFormControl('');

        this.onSearchInputValueChanges = this.searchInput.valueChanges.pipe(
            debounceTime(300),
            distinctUntilChanged(),
        ).
            subscribe((x) => {
                this.taskService.onApplySearchTerm.next(x);
            });

        this.showListToolbar = false;
        this.userReadOnly = this.authService.isUserReadOnly();
    }

    ngOnInit() {
        this.onNewTaskClicked = this.taskService.onNewTaskClicked.subscribe((task: Task) => {
            const taskDlgData: TaskDialogData = new TaskDialogData(task, this.userReadOnly, false, true);
            this.dialog.open(TaskDialogComponent, {
                data: taskDlgData,
            }).afterClosed().subscribe((x) => {
                this.taskService.onSelected.next(x);
            });
        });

        this.route.data.subscribe((x) => {
            const state = this.route.snapshot.paramMap.get('state') || 'all';
            const users = this.route.snapshot.paramMap.get('users') || '';
            const orgId = this.route.snapshot.paramMap.get('org') || '';

            if (x.tasks === 'all') {
                this.taskSelection = enumTaskSelection.AllTasks;
            }
            if (x.tasks === 'my') {
                this.taskSelection = enumTaskSelection.MyTasks;
            }
            if (x.tasks === 'subject') {
                this.taskSelection = enumTaskSelection.SubjectTasks;
            }
            if (x.tasks === 'users') {
                this.taskSelection = enumTaskSelection.UserTasks;
            }
            if (x.tasks === 'filterByUser') {
                this.taskSelection = enumTaskSelection.FilterByUserTasks;
            }
            if (x.tasks === 'created') {
                this.taskSelection = enumTaskSelection.CreatedTasks;
            }
            this.taskService.setTaskSelection(this.taskSelection, users, undefined, Number.parseInt(orgId));
            this.filter = (state) ? new ListFilterItem(state, null, true) : undefined;
            // this.taskService.getTasks();
        });
    }

    ngAfterViewInit() {
        if (this.filter) {
            this.taskService.onApplyFilter.next(this.filter);
        }
    }

    ngOnDestroy() {
        this.onNewTaskClicked?.unsubscribe();
        this.onSearchInputValueChanges?.unsubscribe();
    }

    btnApplyFilter(filter: ListFilterItem) {
        this.taskService.onApplyFilter.next(filter);
    }

    btnApplySortOrder(sortOrder: ListSortOrderItem) {
        this.taskService.onApplySortOrder.next(sortOrder);
    }

    getTitle() {
        switch (this.taskSelection) {
            case enumTaskSelection.AllTasks: return 'All Tasks';
            case enumTaskSelection.MyTasks: return 'My Tasks';
            case enumTaskSelection.SubjectTasks: return 'Subject Tasks';
            default: return 'Tasks';
        }
    }
}
